<template>
  <a-row class="container">
    <a-col :span="24" class="container__title">Контрольные точки</a-col>
    <a-col :span="24">
      <a-row class="container__checkpoints">
        <a-col
          v-for="(checkpoint, index) in checkpoints"
          :key="index"
          class="checkpoints__item"
          :span="24"
        >
          <c-checkpoint
            :status="checkpoint.status"
            :disabled="disabled"
            :competence-status="checkpoint.competenceStatus"
            :volunteering-status="checkpoint.volunteeringStatus"
            @click="
              !disabled && showForm(FORM_NAME_CHECKPOINT_EDIT, checkpoint)
            "
          >
            {{ index + 1 }}.
            <span v-if="checkpoint.date">
              {{ dayjs(checkpoint.date).format('DD.MM.YYYY') }} -
            </span>
            {{ checkpoint.description }}
          </c-checkpoint>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <adding-control
        v-if="!disabled"
        text="Добавить контрольную точку"
        @click="() => showForm(FORM_NAME_CHECKPOINT_ADD, checkpoints[0])"
      />
    </a-col>
  </a-row>

  <drawer-right v-model="isShowingDrawer" @close="onDrawerClose">
    <template v-if="FORM_NAME_CHECKPOINT_ADD === formName">
      <add-check-points :task-id="props.taskId" @updated="onUpdated" />
    </template>
    <template v-else-if="FORM_NAME_CHECKPOINT_EDIT === formName">
      <edit-check-point
        :check-point="checkpoint"
        @updated="onUpdated"
        @delete-action="() => showForm(FORM_NAME_CHECKPOINT_DELETE, checkpoint)"
      />
    </template>
    <template v-else-if="FORM_NAME_CHECKPOINT_DELETE === formName">
      <delete-check-point :check-point="checkpoint" @updated="onUpdated" />
    </template>
  </drawer-right>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import dayjs from 'dayjs';
  import AddCheckPoints from './AddCheckPoints.vue';
  import EditCheckPoint from './EditCheckPoint.vue';
  import DeleteCheckPoint from './DeleteCheckPoint.vue';
  import AddingControl from '@/components/controls/components/AddingControl.vue';
  import CCheckpoint from '@/components/UI/CCheckpoint.vue';
  import DrawerRight from '@/components/drawers/components/DrawerRight.vue';
  import {
    FORM_NAME_CHECKPOINT_ADD,
    FORM_NAME_CHECKPOINT_DELETE,
    FORM_NAME_CHECKPOINT_EDIT,
  } from './constants/form-name';

  const props = defineProps({
    taskId: Number,
    checkpoints: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['update']);

  const checkpoint = ref(null);
  const formName = ref(null);
  const isShowingDrawer = ref(false);

  watch(formName, () => {
    isShowingDrawer.value = null !== formName.value;
  });

  const onDrawerClose = () => {
    formName.value = null;
  };

  const showForm = (name, item) => {
    formName.value = name;
    checkpoint.value = item;
  };

  const onUpdated = () => {
    formName.value = null;
    emit('update');
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
  }

  .container {
    &__title {
      color: $color-bg-status-new;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 20px;
    }

    &__checkpoints {
      .checkpoints__item {
        margin-bottom: 15px;
      }
    }

    &__add-checkpoint {
      margin-left: 30px;

      a {
        border-bottom: 1px solid;
        color: $color-link-primary;
        text-decoration: none;
      }
    }
  }
</style>
